module.exports = __webpack_public_path__ + "img/icon-gpi-nfse.a779ddd0.svg";